import { Controller } from "@hotwired/stimulus"

interface DayEvent extends MouseEvent {
  params: {
    index: string
    url: string
    istoday: boolean
  }
  detail: number
}

export default class extends Controller {
  static targets: string[] = ["note"]
  declare readonly noteTarget: HTMLAnchorElement;
  declare readonly hasNoteTarget: boolean;

  private pressTimer: number | null = null;
  private isLongPress = false;

  start(event: DayEvent) {
    if (event.type === 'mousedown' && event.button !== 0) return;
    if (this.shouldIgnore(event)) return;

    this.isLongPress = false;
    this.clearTimer();

    this.pressTimer = window.setTimeout(() => {
      this.isLongPress = true;
      this.performAction(event, true);
    }, 500);
  }

  end(event: Event) {
    this.clearTimer();
  }

  cancel(event: Event) {
    this.clearTimer();
  }

  private clearTimer() {
    if (this.pressTimer) {
      window.clearTimeout(this.pressTimer);
      this.pressTimer = null;
    }
  }

  disableContextMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  handle(event: DayEvent) {
    if (this.shouldIgnore(event)) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.isLongPress) {
      this.isLongPress = false;
      return;
    }

    this.clearTimer();
    this.performAction(event, false);
  }

  private performAction(event: DayEvent, forceLongPress: boolean) {
    const index = event.params.index;
    const targetUrl = event.params.url;
    const shift = forceLongPress || event.shiftKey;

    const colors = document.getElementById("colors") as HTMLInputElement;
    const indexInput = document.getElementById("input-index") as HTMLInputElement;
    const shiftInput = document.getElementById("input-shift") as HTMLInputElement;
    const moodInput = document.getElementById("input-mood") as HTMLInputElement;
    const intensityInput = document.getElementById("input-intensity") as HTMLInputElement;
    const form = document.getElementById("day-form") as HTMLFormElement;

    if (indexInput) indexInput.value = index;
    if (shiftInput) shiftInput.value = String(shift);
    if (moodInput && colors) moodInput.value = colors.value;
    // intensityInput value is already set by the mood-list controller

    if (!form) return;
    form.action = targetUrl;
    form.requestSubmit();
  }

  private shouldIgnore(event: Event): boolean {
    const target = event.target as HTMLElement;
    return this.hasNoteTarget && (target === this.noteTarget || this.noteTarget.contains(target));
  }
}
